import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  label,
  error,
  leftIcon,
  rightIcon,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-184">
        {label && <label htmlFor={props.id} className="block text-sm font-medium text-text-primary mb-1" data-id="element-185">
            {label}
          </label>}
        <div className="relative rounded-input" data-id="element-186">
          {leftIcon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-187">
              {leftIcon}
            </div>}
          <input className={`block w-full rounded-input border border-border bg-surface-50 px-3 py-2 text-sm placeholder:text-text-tertiary focus:outline-none focus:ring-2 focus:ring-brand-500 ${leftIcon ? 'pl-10' : ''} ${rightIcon ? 'pr-10' : ''} ${error ? 'border-error-500 focus:ring-error-500' : ''}`} ref={ref} {...props} data-id="element-188" />
          {rightIcon && <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-189">
              {rightIcon}
            </div>}
        </div>
        {error && <p className="mt-1 text-xs text-error-500" data-id="element-190">{error}</p>}
      </div>;
});
Input.displayName = 'Input';